import LegalDocPage from './LegalDocPage';

export default LegalDocPage;
